export const columns = [
  {
    title: "任务标题",
    dataIndex: "businessName",
    key: "businessName"
  },
  {
    title: "任务类型",
    dataIndex: "businessType",
    key: "businessType",
    width: 100,
    customRender: text => {
      return text == 1 ? '导出' : '导入';
    }
  },
  {
    title: "任务状态",
    dataIndex: "status",
    key: "status",
    width: 100,
    customRender: text => {
      return {
        0: '待处理',
        1: '处理中',
        2: '成功',
        3: '失败',
        4: '部分成功',
      }[text];
    }
  },
  {
    title: "导出条件",
    dataIndex: "extend",
    key: "extend",
    scopedSlots: { customRender: "extend" }
  },
  {
    title: "成功数",
    dataIndex: "successNum",
    key: "successNum"
  },
  {
    title: "失败数",
    dataIndex: "failNum",
    key: "failNum"
  },
  {
    title: "失败原因",
    dataIndex: "message",
    key: "message",
    width: 400,
    customRender: text => {
      return text ? text : '-';
    }
  },
  {
    title: "操作人",
    dataIndex: "operatorName",
    key: "operatorName"
  },
  {
    title: "操作时间",
    dataIndex: "startTime",
    key: "startTime"
  },
  {
    title: "操作",
    dataIndex: "actions",
    key: "actions",
    width: 150,
    fixed: 'right',
    scopedSlots: { customRender: "action" }
  },
];
